import { styled, TableRow as MuiTableRow } from "@mui/material";
import { getThemeSpacing } from "shared/utils";
import {
  sapphire,
  linkWater,
  gainsboro,
  jordyBlue,
  azureRadiance,
} from "../../../shared/assets/colors";

const PREFIX = "UserGroupOverviewTableRowStyles";
export const classes = {
  cell: `${PREFIX}-cell`,
  typographyValue: `${PREFIX}-typographyValue`,
  typographyLink: `${PREFIX}-typographyLink`,
  typographyLabel: `${PREFIX}-typographyLabel`,
  hoverText: `${PREFIX}-hoverText`,
  icon: `${PREFIX}-icon`,
};

export const TableRow = styled(MuiTableRow)(({ theme }) => ({
  [`& .${classes.cell}`]: {
    border: `1px solid ${gainsboro}`,
  },
  [`& .${classes.typographyValue}`]: {
    color: sapphire,
    textDecoration: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 300,
    whiteSpace: "nowrap",
  },
  [`& .${classes.typographyLink}`]: {
    textDecoration: "none",
    marginLeft: 14,
  },
  [`& .${classes.typographyLabel}`]: {
    color: linkWater,
    marginBottom: 5,
  },
  [`& .${classes.hoverText}`]: {
    "&:hover": {
      color: jordyBlue,
    },
  },
  [`& .${classes.icon}`]: {
    color: azureRadiance,
    fontSize: theme.typography.pxToRem(getThemeSpacing(theme, 2)),
  },
}));
